import { translate } from '../../i18n/index';

export function renderNoMessages() {
  const noMessages = document.createElement('div');
  noMessages.id = 'br-spotlight-no-messages';
  noMessages.classList.add(
    'tw-br-trim-min-h-[150px]', 'tw-br-trim-flex', 'tw-br-trim-items-center', 'tw-br-trim-justify-center',
    'tw-br-trim-font-[18px]', 'tw-br-trim-text-amazon-grey'
  );

  const noMessagesContent = document.createTextNode(translate('br-spotlight-no-new-messages'));
  noMessages.appendChild(noMessagesContent);

  return noMessages;
}
